import React, { Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router';

import { LogoLoading } from "../../components/Loading";
import Sidebar from '../../components/Sidebar';
import { useSelector } from 'react-redux';
import { REPO_HOME_PAGE_URL, REPO_FILE_DETAIL_PAGE_URL, SUPER_ADMIN, REPO_LISTING_PAGE_URL, LOCAL_ADMIN, REPO_USER, OPERATOR } from '../../constants';
// import Header from '../../components/Header';
import { normalLinks } from '../../routes/NormalRoutes/normalLinks';
import { userLinks } from '../../routes/NormalRoutes/userLinks';
import { repoUserLinks } from './repoUserLinks';


// page imports
// const Dashboard = React.lazy(() => import('../../pages/Dashboard'));
// const Profile = React.lazy(() => import('../../pages/Profile'));
// const Categories = React.lazy(() => import('../../pages/Categories'));
// const AddProduct = React.lazy(() => import('../../pages/AddProduct'));
const Orders = React.lazy(() => import('../../pages/Orders'));
const OrderDetail = React.lazy(() => import('../../pages/OrderDetail'));
const ExportOrder = React.lazy(() => import('../../pages/ExportOrder'));
const Users = React.lazy(() => import('../../pages/Users'));
const Statistics = React.lazy(() => import('../../pages/Statistics'));
const Storage = React.lazy(() => import('../../pages/Storage'));
const SearchDetails = React.lazy(() => import('../../pages/SearchDetails'));
const SavedFilters = React.lazy(() => import('../../pages/SavedFilters'));
const HistoryListing = React.lazy(() => import('../../pages/HistoryListing'));
const RedirectDownload = React.lazy(() => import('../../pages/RedirectDownload/RedirectDownload'));
const ClientsPage = React.lazy(() => import('../../pages/Clients'));
const ClientDetails = React.lazy(() => import('../../pages/ClientDetails'));
const ClientsListing = React.lazy(() => import('../../pages/ClientsListing'));
const ClientSavedFilters = React.lazy(() => import('../../pages/ClientSavedFilters'));
const ClientExportsRedirectDownload = React.lazy(() => import('../../pages/ClientExportsRedirectDownload'));
const FileDetails = React.lazy(() => import('../../pages/FileDetails'));
// page imports



function AdminRoutes(props) {
  const user = useSelector(state => state.user);

  return (
    <>
      <Sidebar links={(user.role === SUPER_ADMIN || user.role === LOCAL_ADMIN) ? normalLinks : (user.role === REPO_USER) ? repoUserLinks : userLinks} />
      <Suspense fallback={<LogoLoading />}>
        <Routes>
          {
            (user.role != REPO_USER) &&
            <>
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/export-order" element={<ExportOrder />} />
              <Route path="/export-order/:id" element={<ExportOrder />} />
              <Route path="/saved-filters" element={<SavedFilters />} />
              <Route path="/history-listings" element={<HistoryListing />} />

              <Route path="/clients" element={<ClientsPage />} />
              <Route path="/clients/:id" element={<ClientsPage />} />
              <Route path="/client/:id/details" element={<ClientDetails />} />
              <Route path="/client-listings-status" element={<ClientsListing />} />
              <Route path='/clients-export-file-download/:id' element={<ClientExportsRedirectDownload />} />
              <Route path="/client-saved-filters" element={<ClientSavedFilters />} />
            </>
          }

          {
            (user.role === SUPER_ADMIN || user.role === LOCAL_ADMIN || user.role === OPERATOR) &&
            <>
              <Route path="/users" element={<Users />} />
              <Route path="/statistics" element={<Statistics />} />
            </>
          }

          <Route path={REPO_HOME_PAGE_URL} element={<Storage />} />
          <Route path={`${REPO_FILE_DETAIL_PAGE_URL}/:id`} element={<FileDetails />} />
          <Route path={REPO_LISTING_PAGE_URL} element={<SearchDetails />} />
          {/* <Route path={`${REPO_LISTING_PAGE_URL}/:id`} element={<SearchDetails />} /> */}
          <Route path='/file-download/:id' element={<RedirectDownload />} />

          {
            (user.role != REPO_USER) ?
              <Route path='*' element={<Navigate to="/orders" />} />
              : <Route path='*' element={<Navigate to={REPO_HOME_PAGE_URL} />} />
          }
        </Routes>
      </Suspense>
    </>
  )
}

export default AdminRoutes
